module.exports = __webpack_public_path__ + "static/media/ice5.9eb49415.png";